import qs from "qs";
import { CreateAxiosDefaults } from "axios";

import ENVIRONMENT_VAR from "../environment/environments.var";

const headers = {
  "access-control-allow-origin": "*",
  "x-api-key": ENVIRONMENT_VAR.API_KEY,
  "x-requested-with": "XMLHttpRequest",
  "content-type": "multipart/form-data"
};

export const CConfigAxios: CreateAxiosDefaults<any> | undefined = {
  baseURL: ENVIRONMENT_VAR.API_URL,
  headers: headers,
  paramsSerializer: {
    encode: (params: any) =>
      qs.stringify(params, { arrayFormat: "repeat" })
  }
};
